import { experimentTemplateSelectorReducer } from "../components/ExperimentTemplateSelector/ExperimentTemplateSelector.ducks.js";
import { combineReducers } from "redux";
import { managementGroupProviderReducer } from "../components/ManagementGroupProvider/ManagementGroupProvider.ducks.js";
import managementGroupSelectorReducer from "@ane/exp-ux/lib/components/ManagementGroupSelector/ManagementGroupSelector.ducks";
const reducer = combineReducers({
  experimentTemplateSelector: experimentTemplateSelectorReducer,
  managementGroupSelector: managementGroupSelectorReducer,
  managementGroupProvider: managementGroupProviderReducer
});
export {
  reducer as default,
  reducer
};
//# sourceMappingURL=ducks.js.map
